export const getBrands = () => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/brands`,
  }
}

export const getBrandYears = (brand: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/years?brand=${brand}`,
  }
}

export const getModels = (brand: string, year: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/models?brand=${brand}&year=${year}`,
  }
}

export const getVariants = (brand: string, year: string, model: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/variants?brand=${brand}&year=${year}&model=${model}`,
  }
}
export const getAvailableCalendar = (zipCode: string, locationId: string) => {
  const today = new Date()
  today.setUTCHours(0, 0, 0, 0)

  const oneMonth = new Date()
  oneMonth.setMonth(oneMonth.getMonth() + 1)

  return {
    method: 'POST',
    body: {
      zipCode,
      locationId,
      fromDate: today.getTime(),
      toDate: oneMonth.getTime(),
    },
    url: `${process.env.REACT_APP_ORIGIN}/scheduling/available-calendar`,
  }
}

export const updateCustomer = (body: any) => {
  return {
    method: 'PUT',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/customers`,
  }
}

export const updateCustomerVehicle = (body: any) => {
  return {
    method: 'PUT',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/customer_vehicles`,
  }
}
export const createCustomerVehicle = (body: any, customerId: string) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/customer_vehicles/${customerId}`,
    body: body,
  }
}

export const setCustomerVehicle = (orderId: string, vehicleObjectId: string) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/vehicles/bulk`,
    body: [vehicleObjectId],
  }
}

export const createInstallationPoint = (body: any) => {
  return {
    method: 'POST',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/installation_point`,
  }
}

export const setInstallationPoint = (installationPoint: any, orderId: string) => {
  return {
    method: 'POST',
    body: installationPoint,
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/installation-point`,
  }
}
export const updateInstallationPoint = (body: any) => {
  return {
    method: 'PUT',
    body,
    url: `${process.env.REACT_APP_ORIGIN}/installation_point`,
  }
}
export const getStateByZip = (zipCode: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/states`,
  }
}
